// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bbq_a bhy_i bhy_j","ColorVariants__color":"bbq_b bhy_rp","ColorVariants__more":"bbq_c bhy_vv"};